import React from 'react';
import ReactDOM from 'react-dom';


class Protected extends React.Component {
	render() {
		return (
			 <div>
			 	{this.props.children}
			 </div>
		);
	}
}

export default Protected;


// WEBPACK FOOTER //
// ./containers/Protected.js